import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import { useAppMeta } from "hooks";

import { useCreatePrepaymentMutation } from "store/services/PaymentsApi/prepaymentApi";

import PrepaymentForm from "./PrepaymentComponents/PrepaymentForm";

const PrepaymentCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Prepayments", path: "/app/crm/prepayment/list" },
    { title: "New Prepayment" },
  ];

  const [createPrepayment, { isLoading: creatingPrepayment }] =
    useCreatePrepaymentMutation();

  // methods
  const handleAddPrepayment = async (data) => {
    try {
      const { _id } = await createPrepayment(data).unwrap();
      toast.success("Prepayment Created!");
      navigate(`/app/crm/prepayment/${_id}/detail`);
    } catch (error) {
      toast.error(
        error?.data?.message ?? error.message ?? "Could Not Create Prepayment!"
      );
    }
  };

  useAppMeta("New Prepayment");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingPrepayment}>
      <BreadcrumbLayout.Paper>
        <PrepaymentForm
          isBusy={creatingPrepayment}
          onSubmit={handleAddPrepayment}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default PrepaymentCreateScreen;
